module.exports = __webpack_public_path__ + "static/media/Casino-Days-Two-Lines-Gradient-BG-600x600.f4d2473a.png";